<template>
  <div v-if="loading">
    <spinner :show="loading"/>
  </div>
  <TabLayout v-else class="marketing-view" :tabs="tabs">
    <template v-slot:title>
      <artisio-breadcrumb :items="breadcrumbs"/>
    </template>
  </TabLayout>
</template>

<script>
  import TabLayout from "@/core/components/layout/DefaultLayout/TabLayout";
  import i18n from "@/shared/i18n";
  import {createNamespacedHelpers} from "vuex";
  import Spinner from "@/core/components/common/Spinner";
  import ArtisioBreadcrumb from "@/core/components/artisio-breadcrumb/ArtisioBreadcrumb";

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "AudienceView",
    components: {
      ArtisioBreadcrumb,
      Spinner,
      TabLayout
    },
    data() {
      return {
        breadcrumbs: [],
        tabs: [
          {title: i18n.t('Customers'), icon: 'users', to: {name: 'marketing.audience.customers'}},
          // {title: i18n.t('Campaigns'), icon: 'envelope', to: {name: 'marketing.audience.campaigns'}},
        ]
      }
    },
    computed: {
      ...mapState({
        audience: state => state.view.audience,
        loading: state => state.view.loading,
      })
    },
    methods: {
      ...mapActions(['getAudience']),
      initBreadcrumbs() {
        this.breadcrumbs = [
          {
            text: this.$i18n.t('Marketing'),
            to: {name: 'marketing'},
            icon: 'mail-bulk'
          },
          {
            text: this.audience.name
          }
        ];
      }
    },
    async beforeMount() {
      const response = await this.getAudience(this.$route.params.id);

      if (!response.success) {
        await this.$errorDialog(this.$i18n.t('Something went wrong'));
        this.$generalGoBack(this)
      } else {
        this.initBreadcrumbs();
      }
    }
  }

</script>

<style lang="scss">
  @import "./../scss/variables";

  .marketing-view {
    @include view-page-wrapper;

    .page-header {
      min-height: 50px;
    }
  }

</style>
